import React from 'react';
import { motion } from 'framer-motion';
import { ServicePageHero } from '../components/ServicePageHero';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function Ancillaries() {
  const features = ['Industrial hosing & connectors', 'Thermal transfer units', 'Secure fuel storage', 'Temporary power generation', 'Circulation pumps', 'Air distribution ducting'];
  return <main className="flex-grow" data-id="element-211">
      <ServicePageHero title="Ancillary Equipment" subtitle="The essential supporting infrastructure required to execute complex temporary HVAC deployments safely." data-id="element-212" />

      <section className="py-20 bg-white" data-id="element-213">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-215">
            {/* Content Left */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-2/3" data-id="element-216">
              <h2 className="text-3xl font-heading font-bold text-brand-navy mb-6" data-id="element-217">
                Comprehensive System Integration
              </h2>

              <div className="space-y-6 text-brand-slate text-lg leading-relaxed mb-10" data-id="element-218">
                <p data-id="element-219">
                  An effective temporary climate control project demands more
                  than merely the primary heating or cooling plant. We supply a
                  complete portfolio of premium ancillary components to
                  guarantee your deployment is secure, highly efficient, and
                  seamlessly connected to your facility's existing
                  infrastructure.
                </p>
                <p data-id="element-220">
                  Our stock includes certified food-grade hosing, heavy-duty air
                  distribution ducting, plate heat exchangers, domestic hot
                  water calorifiers, and specialized circulation pumps.
                  Furthermore, we provide reinforced fuel storage solutions and
                  temporary power generators to facilitate autonomous operation
                  in locations lacking adequate utilities.
                </p>
                <p data-id="element-221">
                  Procuring all necessary components from a single specialist
                  ensures absolute system compatibility and simplifies your
                  supply chain. Our technical team determines the precise
                  ancillary requirements during the preliminary site audit,
                  guaranteeing a frictionless installation phase.
                </p>
                <p data-id="element-222">
                  Every piece of supporting equipment undergoes stringent
                  testing and maintenance protocols, delivering the
                  uncompromising reliability demanded by critical commercial
                  applications.
                </p>
              </div>

              <h3 className="text-xl font-heading font-bold text-brand-navy mb-6" data-id="element-223">
                System Capabilities
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-224">
                {features.map((feature, i) => <span key={i} className="bg-brand-light border border-gray-200 text-brand-navy px-4 py-2 rounded-full text-sm font-medium" data-id="element-225">
                    {feature}
                  </span>)}
              </div>
            </motion.div>

            {/* Sidebar Right */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/3 w-full sticky top-24" data-id="element-226">
              <div className="bg-brand-navy p-8 rounded-xl text-white mb-8" data-id="element-227">
                <h3 className="text-xl font-heading font-bold mb-4" data-id="element-228">
                  Quick Inquiry
                </h3>
                <p className="text-sm text-gray-400 mb-6" data-id="element-229">
                  Need supporting equipment? Call our 24/7 dispatch team.
                </p>
                <a href="tel:08004647025" className="block w-full text-center bg-brand-amber text-brand-navy font-bold py-3 rounded hover:bg-white transition-colors" data-id="element-230">
                  0800 464 7025
                </a>
              </div>
              <img src="https://rapidenergy.co.uk/wp-content/uploads/2026/03/Rapid-Energy-van-next-to-packaged-boiler.webp" alt="Equipment Setup" className="rounded-xl shadow-lg w-full object-cover" data-id="element-231" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Other Services Strip */}
      <section className="bg-brand-light py-8 border-y border-gray-200" data-id="element-232">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-233">
          <span className="text-brand-slate font-medium" data-id="element-234">Explore more:</span>
          <Link to="/boiler-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-235">
            Temporary Boilers
          </Link>
          <Link to="/chiller-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-236">
            Industrial Chillers
          </Link>
          <Link to="/cooling-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-237">
            Cooling Systems
          </Link>
        </div>
      </section>

      <CTASection data-id="element-238" />
    </main>;
}